import PropTypes from 'prop-types';
import { Button as MuiButton } from '@mui/material';
import './Button.scss';

export const Button = (props) => {
  const {
    children,
    text,
    onClick,
    variant = 'primary',
    extendClass,
    extendTestId,
    disabled,
    ...rest
  } = props;

  const disabledClass = disabled ? 'disabled' : '';
  const containerClasses = ['button__container', disabledClass].join(' ');
  const classes = ['acm-button', variant, extendClass, disabledClass].join(' ');
  const extendTestIdStr = extendTestId ? `${extendTestId}-` : '';

  return (
    <div className={containerClasses}>
      <MuiButton
        {...rest}
        onClick={onClick}
        className={classes}
        disabled={disabled}
        data-testid={`${extendTestIdStr}button`}
        disableRipple
        disableTouchRipple
        focusRipple={false}
      >
        {text || children}
      </MuiButton>
    </div>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  onClick: PropTypes.func,
  extendClass: PropTypes.string,
  disabled: PropTypes.bool,
  extendTestId: PropTypes.string,
};
